import { PRODUCTS_URL } from '../constants';
import { apiSlice } from './apiSlice';

export const productsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProductDetails: builder.query({
      query: (ean) => ({
        url: ean ? `${PRODUCTS_URL}/${ean}` : null,
      }),
      transformResponse: (response, meta) => {
        // console.log("Raw response from backend:", response);
        if (meta?.response?.status === 404) {
          return { message: "Product not found", offer_price: 0, source: "N/A" };
        }
        return response;
      },
      keepUnusedDataFor: 5,
    }),    
  }),
});

export const {
  useGetProductDetailsQuery,
  useLazyGetProductDetailsQuery,
  } = productsApiSlice;